/**
 * Records Tab
 */
import Vue from 'vue'
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const RECORD_ID_SCHEME = {
  info: [],
  scheme: [],
  schemeName: 'record_public_id_scheme',
  template: 'standard1',
}

export const RecordsSettingsState = {
  recordsSettingsLoading: false,
  recordsSettings: {},
}

export const RecordsSettingsActions = {
  createRecordsSettings: async ({ commit }, value) => {
    commit('setRecordsSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'record_public_id_scheme',
        value,
      }).
      then(({ data }) => {
        commit('setRecordsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setRecordsSettingsLoading', false))
  },

  getRecordsSettings: async ({ commit }) => {
    commit('setRecordsSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/record_public_id_scheme').
      then(({ data }) => {
        commit('setRecordsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setRecordsSettingsLoading', false))
  },

  updateRecordsSettings: async ({ getters, commit }, value) => {
    commit('setRecordsSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.recordsSettingsId}`, {
        name: 'record_public_id_scheme',
        value,
      }).
      then(({ data }) => {
        commit('setRecordsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setRecordsSettingsLoading', false))
  },

  deleteRecordsSettings: async ({ getters, commit }) => {
    commit('setRecordsSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.recordsSettingsId}`).
      then(({ data }) => {
        commit('setRecordsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setRecordsSettingsLoading', false))
  },
}

export const RecordsSettingsMutations = {
  setRecordPublicIdScheme: (state, payload) => { state.recordPublicIdScheme = payload },
  setRecordPublicIdSchemeInfo: (state, { index, data }) => { Vue.set(state.recordPublicIdScheme.info, index, data) },
  setRecordsSettings: (state, payload) => { state.recordsSettings = payload },
  setRecordsSettingsLoading: (state, payload) => { state.recordsSettingsLoading = payload },
}

export const RecordsSettingsGetters = {
  recordsSettings: state => state.recordsSettings,
  recordsSettingsLoading: state => state.recordsSettingsLoading,
  recordsSettingsValue: state => state.recordsSettings?.value || { ...RECORD_ID_SCHEME },
  recordsSettingsId: state => state.recordsSettings?.id,
}
